import { useState } from 'react';

interface DemoPlayerProps {
  poster: string;
  title: string;
  episodeTitle: string;
}

export default function DemoPlayer({ poster, title, episodeTitle }: DemoPlayerProps) {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-background-950 border border-background-200/70">
      <img
        src={poster}
        alt={`${title} 播放画面`}
        title={`${title} 演示播放器`}
        className="w-full h-full object-cover object-top opacity-55"
      />
      <div className="absolute inset-0 bg-background-950/45" />

      <button
        type="button"
        onClick={() => setPlaying((v) => !v)}
        aria-label={playing ? '暂停' : '播放'}
        className="absolute inset-0 flex items-center justify-center group cursor-pointer"
      >
        <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-500/95 flex items-center justify-center text-background-950 transition-transform duration-300 group-hover:scale-105">
          <i className={playing ? 'ri-pause-fill text-3xl' : 'ri-play-fill text-3xl'} />
        </span>
      </button>

      <div className="absolute top-3 left-3 md:top-4 md:left-4 px-3 py-1 rounded-md bg-background-950/70 text-xs md:text-sm text-foreground-900">
        {episodeTitle}
      </div>

      <div className="absolute bottom-0 inset-x-0 p-3 md:p-4 bg-gradient-to-t from-background-950 to-transparent flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 text-[11px] md:text-xs text-foreground-700">
          <i className="ri-information-line text-sm" />
          播放功能为演示状态，待后端接口接入
        </span>
        <span className="shrink-0 px-2 py-0.5 rounded bg-accent-500 text-background-950 text-[11px] font-semibold whitespace-nowrap">
          演示播放器
        </span>
      </div>
    </div>
  );
}